export default __webpack_public_path__ + "static/media/Instagramm_weiß.2dc785e8.png";